export const IS_LOADING = 'IS_LOADING';
export const NOT_LOADING = 'NOT_LOADING';
export const SET_CONFIG = 'SET_CONFIG';

export default { IS_LOADING, NOT_LOADING, SET_CONFIG };
